"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var StyledMuiTabs = (0, styles_1.styled)(material_1.Tabs)(function (_a) {
    var theme = _a.theme;
    return ({
        maxHeight: '100%',
        textAlign: 'left',
        border: '1px solid transparent',
        position: 'relative',
        ' > div:first-of-type': {
            position: 'absolute',
            height: '100%',
            zIndex: 999,
            background: 'linear-gradient(to right, rgb(255,255,255,1), rgb(255,255,255,0))',
        },
        ' > div:last-of-type': {
            background: 'linear-gradient(to left, rgb(255,255,255,1), rgb(255,255,255,0))',
            position: 'absolute',
            height: '100%',
            zIndex: 999,
            right: 0,
        },
        '.MuiTabs-scroller': {
            overflowY: 'hidden',
        },
        '.MuiTabs-flexContainer': { height: '100%' },
        '.MuiTabScrollButton-root': {
            width: 32,
            opacity: 1,
            '&:hover': {
                '& .MuiTouchRipple-root': { background: '#ebebeb' },
            },
        },
        '.MuiTabScrollButton-root.Mui-disabled': { opacity: 0 },
        '.MuiTouchRipple-root': { opacity: '0.8' },
        '.MuiTab-wrapper': {
            display: 'block',
            padding: 0,
            margin: 0,
        },
        '.MuiTab-root': {
            '&:first-child': {
                marginLeft: theme.spacing(2),
            },
            '&:last-child': {
                marginRight: theme.spacing(4),
            },
            padding: 0,
            margin: theme.spacing(0, 1),
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%',
            fontFamily: 'Fellix',
            fontWeight: 500,
            lineHeight: 1.2,
            whiteSpace: 'normal',
            letterSpacing: '0.015em',
            textTransform: 'none',
            opacity: 1,
        },
        '.MuiTabs-indicator': {
            background: 'none',
        },
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(StyledMuiTabs, {
    variant: 'scrollable',
    scrollButtons: true,
});
